var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-content"},[_c('span',[_vm._v("科技让生活更美好")]),_vm._v(" "),_c('div',{staticClass:"nav-content-div",on:{"click":_vm.logout}},[_vm._v("退出")]),_vm._v(" "),_c('div',{staticClass:"nav-content-name",staticStyle:{"display":"inline-block","float":"right"}},[_vm._v(_vm._s(_vm.$store.state.accountName))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6b74bd2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar.vue
// module id = null
// module chunks = 